export const yamazaki_red = "#bf2327";
export const yamazaki_brown = "#723B17";
export const background_color_grey = "#F8F6F4";
export const background_color_rice = "#FBF7F1";
export const yamazaki_yellow = "#F5D6A7";